import { Component, OnInit, ViewChild, Input, effect, inject, Injector, ChangeDetectorRef, WritableSignal } from "@angular/core"; import { Location } from "@angular/common";
import { Table } from 'primeng/table';
import { BreadcrumbService } from '../../app.breadcrumb.service';

import { CommandeService } from '../../services/commande-service';
import { CommandeMin } from '../../entites/commande-min';
import { MenuItem } from 'primeng/api/menuitem';
import { MessageService, LazyLoadEvent, ConfirmationService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

import { DialogService } from 'primeng/dynamicdialog';
import { Router, ActivatedRoute } from '@angular/router';
import { Emplacement } from 'src/app/entites/emplacement';
import { EmplacementService } from 'src/app/services/emplacement-service';
import { BaseComponent } from 'src/app/base/base-component';
import { DonneesBaseService } from 'src/app/services/donnees-base-service';
import { ProfilService } from 'src/app/services/profil-service';
import { AppMainComponent } from 'src/app/app.main.component';
import { SignalWithWatcher } from 'src/app/services/base.service';
import { ReponseBase } from 'src/app/services/reponse-base';
import { ItemCommandeEntite } from "src/app/entites/item-commande";

@Component({
    templateUrl: './approbation-precommandes.component.html',
    styleUrls: ['./approbation-precommandes.component.scss'],
    styles: [`
        @media screen and (max-width: 960px) {
            :host ::ng-deep .p-datatable.p-datatable-customers.rowexpand-table .p-datatable-tbody > tr > td:nth-child(6) {
                display: flex;
            }
        }

    `],
    providers: [MessageService, ConfirmationService, DialogService]
})
export class ApprobationPrecommandesComponent extends BaseComponent implements OnInit {

    selectionCommande: Emplacement;
    
    listeEmplacementsActifs: Emplacement[];
    listeEmplacementsFiltres: Emplacement[];
    searchTerm: string = '';
    
    viewOptions: any[] = [{ label: 'Tableau', value: 'tableau' },{ label: 'Cartes', value: 'cartes' }];
    value: WritableSignal<string> = this.createLocalStorageSignal('approbation_precommandes_view', 'cartes');

    @ViewChild('dt') table: Table;
    
    injector = inject(Injector);
    private cdr = inject(ChangeDetectorRef);

    private approbationsSignalWatcher: SignalWithWatcher<ReponseBase<Emplacement[]>>;

    constructor(
        sdb: DonneesBaseService,
        profilService: ProfilService,
        route: ActivatedRoute, 
		appMain: AppMainComponent, location: Location, 
        private breadcrumbService: BreadcrumbService,
        private CommandesService: CommandeService,
        private emplacementService: EmplacementService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        public dialogService: DialogService,
        public routerService: Router) {
        
            super(sdb, profilService, route, routerService, appMain);
            this.breadcrumbService.setItems([
                { label: 'Approbation de commandes' }
            ]);

    }

    ngOnInit() {

        this.verifierAccesPage('approbation_precommande');
        this.DemarrerChargement();

        this.CommandesService.ObtenirApprobationsPrecommande().subscribe({
            next: (response: ReponseBase<Emplacement[]>) => {
                this.listeEmplacementsActifs = response.valeur;
                this.listeEmplacementsFiltres = [...this.listeEmplacementsActifs];
                this.CompleterChargement();
            },
            error: (error) => {
                this.messageService.add({severity:'error', summary:'Erreur', detail:error.error || error, life: 3000});
            }
        });
    }

    OuvrirDetailCommande(emplacementId: number) {
        this.routerService.navigateByUrl(`commandes/approbation/${emplacementId}`)
    }
    
    onSearch(event: any) {
        const searchValue = event.target.value.toLowerCase();
        this.searchTerm = searchValue;
        
        if (this.value() === 'cartes') {
            // Filter for card view
            this.listeEmplacementsFiltres = this.listeEmplacementsActifs.filter(emplacement => 
                emplacement.nom.toLowerCase().includes(searchValue) || 
                emplacement.code.toLowerCase().includes(searchValue)
            );
        } else {
            // Filter for table view
            if (this.table) {
                this.table.filterGlobal(searchValue, 'contains');
            }
        }
    }

    refresher() {
        this.ngOnInit();
        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Commandes rafraîchies' });
    }
}
